import { gql } from '@apollo/client';

export const markNotificationsAsSeenMutation = gql`
  mutation MarkNotificationsAsSeen {
    markAsSeen(input: {}) @rest(type: "MarkNotificationAsSeenPayload", path: "messages/mark-as-seen", method: "POST") {
      NoResponse
    }
  }
`;
